const stripHtml = (html) => {
  return html && html.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ');
};

export { stripHtml };
